// src/services/ConversationFilesService.ts
import { BaseService } from "@services/BaseService";

export type UploadedConversationFile = {
  id: string;
  filename: string;
  filetype: string;
  size?: number;
  status?: number;
  uploaded_at?: string;
  conversation_id?: number;
};

type ListFilesResp = { files: UploadedConversationFile[] };

class ConversationFilesService extends BaseService {
  async listConversationFiles(conversation_id: number | string) {
    const res = await this.get<ListFilesResp>(
      `/chat/conversations/${conversation_id}/files/`
    );
    // unwrap AxiosResponse<T> -> T
    // @ts-expect-error BaseService likely returns AxiosResponse
    return res?.data ?? res;
  }

  async uploadConversationFile(
    conversation_id: number | string,
    file: File,
    overwrite = true
  ) {
    const fd = new FormData();
    fd.append("uploaded_file", file);

    // API may return either UploadedConversationFile or { file: UploadedConversationFile }
    const res = await this.post(
      `/chat/conversations/${conversation_id}/upload-file/?overwrite=${
        overwrite ? "true" : "false"
      }`,
      fd
    );

    // unwrap AxiosResponse
    const data = res?.data ?? res;
    return (data as any).file
      ? ((data as any).file as UploadedConversationFile)
      : (data as UploadedConversationFile);
  }

  async deleteConversationFile(
    conversation_id: number | string,
    file_id: number | string
  ) {
    const res = await this.delete<void>(
      `/chat/conversations/${conversation_id}/files/${file_id}`
    );
    // unwrap if needed
    // @ts-expect-error BaseService likely returns AxiosResponse
    return res?.data ?? res;
  }
}

export const conversationFilesService = new ConversationFilesService();
